import Link from 'next/link'
import { Text } from 'ui-kit/typography'
import { removeEmptyQueries } from 'helpers/querystring'
import { CategoryCompactType } from 'routes/Integrations/helpers/types'
import {
  getReadableCategoryName,
  isEqualCategories,
  setFilteredIntegrationsCount,
} from 'routes/Integrations/helpers'
import clsx from 'clsx'
import classes from './IntegrationsCategoriesGrid.module.scss'

export const IntegrationsCategoriesGridItem = ({
  item,
  filteredCategories,
  loading,
  selectedCategory,
  onChange,
}: {
  item: CategoryCompactType
  filteredCategories: CategoryCompactType[]
  loading: boolean
  selectedCategory?: string
  onChange: (category: string) => void
}) => {
  const { category } = item

  function handleCategoryChange(category: string) {
    onChange(category)
  }

  return (
    <li className={classes.item}>
      <Link
        href={{
          query: removeEmptyQueries({
            category: category,
          }),
        }}
        onClick={() => {
          handleCategoryChange(category as string)
        }}
        passHref
        shallow
        className={clsx(
          classes.link,
          isEqualCategories(selectedCategory, category) && classes.link__active,
        )}
      >
        {getReadableCategoryName(category)}
        <Text
          as={'span'}
          className={clsx(classes.amount, loading && classes.amount__loading)}
        >
          {!loading && setFilteredIntegrationsCount(item, filteredCategories)}
        </Text>
      </Link>
    </li>
  )
}
